import { render, staticRenderFns } from "./homebottom5.vue?vue&type=template&id=362c00b8&scoped=true"
import script from "./homebottom5.vue?vue&type=script&lang=js"
export * from "./homebottom5.vue?vue&type=script&lang=js"
import style0 from "./homebottom5.vue?vue&type=style&index=0&id=362c00b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c00b8",
  null
  
)

export default component.exports